/**
 * @fileoverview Vuex getters for WhatsApp computed state.
 *
 * @module store/modules/whatsapp/getters
 *
 * Currently empty - getters can be added here for computed WhatsApp state.
 */

import { GetterTree } from "vuex/types";
import { RootState } from "@/store/types";
import { WhatsAppState } from "./types";

const getters: GetterTree<WhatsAppState, RootState> = {};

export default getters;
